<template>
  <div style="background-color: #f6f6f6;padding-bottom: 1px;margin-top: 30px;">
   <b-container fulid class="bv-example-row">
    <b-row >
      <p class="p1">合作流程</p></b-row>
      <b-row >
      <b-col cols="12" sm="12" md="3" lg="3" xl="3" class="wei">
        <b-img :src="img_1" class="imgs"></b-img>
        <b-img :src="img_5" class="jian"></b-img>
        <!-- <div class="text">提交</div>
        <div class="text">合作需求</div> -->
      </b-col>
      <b-col cols="12" sm="12" md="3" lg="3" xl="3" class="wei">
        <div>
          <b-img :src="img_2" class="imgs"></b-img>
          <b-img :src="img_5" class="jian"></b-img>
        </div>
        <!-- <div class="text">前期</div>
        <div class="text">业务沟通</div> -->
      </b-col>
      <b-col cols="12" sm="12" md="3" lg="3" xl="3" class="wei">
        <b-img :src="img_3" class="imgs"></b-img>
        <b-img :src="img_5" class="jian"></b-img>
        <!-- <div class="text">确定</div>
        <div class="text">合作模式</div> -->
      </b-col>
      <b-col cols="12" sm="12" md="3" lg="3" xl="3">
        <b-img :src="img_4" class="imgs"></b-img>
        <!-- <div class="text">开展</div>
        <div class="text">业务合作</div> -->
      </b-col>
    </b-row>
   </b-container>
  </div>
</template>
<script>
export default {
  name:'cooperate',
  data(){
    return{
      img_1:require('../../../stater/he1.png'),
      img_2:require('../../../stater/he2.png'),
      img_3:require('../../../stater/he3.png'),
      img_4:require('../../../stater/he4.png'),
      img_5:require('../../../stater/jian_ri.png'),
    }
  }
}
</script>
<style scoped>
.p1{
  text-align: center;
  font-size: 22px;
    font-weight: 500;
    width: 100%;
    /* margin-bottom: 17px; */
    background-color: #f6f6f6;
    line-height: 58px;
    white-space: nowrap;
}
.imgs{
  width: 150px;
  height: 150px;
  margin-bottom: 15px;
}
.text{
  font-size: 18px;
    font-weight: 600;
}
.wei{
  position: relative;
  margin-bottom:15px
}
.jian{
  position: absolute;
  width: 70px;
  height: 40px;
  top: 3rem;
  margin-left: 2.4rem;
}
@media screen and (max-width: 1194px) {
  .jian{
  margin-left: 0.4rem;
}
}
@media screen and (max-width: 986px) {
  .jian{
    display: none;
  }
}
</style>